import { QueryClientProvider } from '@tanstack/react-query';
import { ContextBuilder } from '@unboilr/react';
import { useApiClient } from '../hooks/useApiClient';

export type ApiResponse<TData = unknown, TConfig = unknown> = {
  data: TData;
  message?: string;
  errors?: { errorCode: string; errorMessage: string }[];
  config: TConfig | null;
};

export interface PaginatedApiResponse<T> extends ApiResponse<T> {
  meta: {
    pagination: {
      currentPage: number;
      totalItems: number;
      hasPrevPage: boolean;
      hasNextPage: boolean;
      pageSize: number;
      totalPages: number;
    };
    additionalValue: {
      [key: string]: string;
    };
  };
}

export interface Pagination {
  currentPage: number;
  totalItems: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  pageSize: number;
  totalPages: number;
}
export interface additionalValue {
  [key: string]: string;
}
export const [RawApiClientProvider, useApiClientCtx] = ContextBuilder(useApiClient, {
  name: 'ApiClient',
});

export const ApiClientContextController = ({ children }: { children: React.ReactNode }) => {
  const { queryClient } = useApiClient();

  return (
    <QueryClientProvider client={queryClient}>
      <RawApiClientProvider>{children}</RawApiClientProvider>
    </QueryClientProvider>
  );
};
